import { Analytics, getAnalytics } from 'firebase/analytics'
import { FirebaseApp, initializeApp } from 'firebase/app'
import { Auth, getAuth } from 'firebase/auth'
import { Firestore, getFirestore } from 'firebase/firestore'
import { getMessaging, isSupported, Messaging } from 'firebase/messaging'

import { env } from '@/env'

const firebaseConfig = {
  apiKey: env.VITE_API_KEY,
  authDomain: env.VITE_AUTH_DOMAIN,
  databaseURL: env.VITE_DATABASE_URL,
  projectId: env.VITE_PROJECT_ID,
  storageBucket: env.VITE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_MESSAGING_SENDER_ID,
  appId: env.VITE_APP_ID,
  measurementId: env.VITE_MEASUREMENT_ID,
}

let firebase: FirebaseApp | null = null
let db: Firestore
let auth: Auth
let analytics: Analytics | null = null
let messagingPromise: Promise<Messaging | null> | null = null

if (typeof window !== 'undefined') {
  firebase = initializeApp(firebaseConfig)
  db = getFirestore(firebase)
  analytics = getAnalytics(firebase)
}

export const getFirebaseAuth = () => {
  if (!auth) auth = getAuth(firebase as FirebaseApp)
  return auth
}

// getMessaging() throws `messaging/unsupported-browser` on browsers without
// Service Worker / Push API (Firefox iOS, WebViews, Safari private mode), so
// it must stay behind isSupported() instead of running at module scope.
export const getMessagingIfSupported = (): Promise<Messaging | null> => {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => (supported && firebase ? getMessaging(firebase) : null))
      .catch(() => null)
  }
  return messagingPromise
}

export { analytics, auth, db, firebase }
